var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:[{'main-menu': _vm.mainMenu}]},[_c('ul',{class:[{right: _vm.right}]},_vm._l((_vm.navLinks),function(link,i){return _c('MenuItem',{key:("link-" + i),attrs:{"link":link}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }